"use client"

import { colors, mediaQueries } from "@/ui/theme/theme"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"

// Styled components for the top section
export const TopCard = styled(Box)`
  background-color: ${colors.white};
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 4px 16px rgba(90, 90, 90, 0.05);
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Title = styled(Typography)<{ component?: string }>`
  color: ${colors.black};
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 24px;
  text-align: center;

  ${mediaQueries.mobile} {
    font-size: 22px;
  }
`

export const ItemsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  width: 100%;

  //   ${mediaQueries.mobile} {
  //     flex-direction: column;
  //     gap: 16px;
  //   }
  ${mediaQueries.desktopXl} {
    width: 70%;
  }
`

export const MemberItem = styled(Box)`
  display: flex;
  align-items: center;
`

export const MemberName = styled(Typography)`
  font-weight: 700;
  color: ${colors.black};
  margin-right: 8px;
`

export const MemberRole = styled(Typography)`
  font-weight: 400;
  color: ${colors.black};
  margin-left: 8px;
`

export const Divider = styled(Box)`
  height: 16px;
  width: 1px;
  background-color: ${colors.red};
  margin: 0 8px;
`

// Styled components for the bottom section (committees)
export const CommitteesContainer = styled(Box)`
  margin-top: 40px;
`

export const CommitteesGrid = styled(Box)`
  display: grid;
  gap: 24px;

  ${mediaQueries.mobile} {
    grid-template-columns: 1fr;
  }
  ${mediaQueries.tablet} {
    grid-template-columns: 1fr 1fr;
  }
  ${mediaQueries.desktopM} {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const CommitteeCard = styled(Box)`
  background-color: ${colors.white};
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 4px 16px rgba(90, 90, 90, 0.05);
  display: flex;
  flex-direction: column;
`

export const CommitteeName = styled(Typography)<{ component?: string }>`
  font-weight: 700;
  color: ${colors.black};
  font-size: 20px;
  margin-bottom: 12px;
  text-align: start;
`

export const CommitteeDescription = styled(Typography)`
  font-weight: 400;
  color: ${colors.red};
  margin-bottom: 16px;
`

export const CommitteeMembers = styled(Box)`
  color: ${colors.black};
`
